import api from './api';

const normalizeRegion = (region) => region.startsWith('oss-') ? region : `oss-${region}`;

let oss_module;

const loadOss = async () => {
  if (!oss_module) {
    const module = await import('ali-oss');
    oss_module = module.default || module;
  }
  return oss_module;
};

const createOssClient = async (sts_data) => {
  const OSS = await loadOss();
  const client_options = {
    region: normalizeRegion(sts_data.region),
    bucket: sts_data.bucket,
    accessKeyId: sts_data.credentials.accessKeyId,
    accessKeySecret: sts_data.credentials.accessKeySecret,
    stsToken: sts_data.credentials.stsToken,
    secure: true,
  };

  if (sts_data.endpoint) client_options.endpoint = sts_data.endpoint;
  return new OSS(client_options);
};

export const uploadFileToOss = async (file_type, file) => {
  const response = await api.post('/oss/sts', {
    fileType: file_type,
    fileName: file.name,
  });
  const sts_data = response.data;
  const client = await createOssClient(sts_data);

  await client.put(sts_data.objectKey, file);

  return {
    objectKey: sts_data.objectKey,
    name: file.name,
  };
};

export const downloadOssFile = async (request_path, file_name) => {
  const response = await api.get(request_path, { responseType: 'blob', timeout: 0 });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', file_name);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const previewOssPdf = async (request_path) => {
  const response = await api.get(request_path, { responseType: 'blob', timeout: 0 });
  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const preview_window = window.open(url, '_blank');
  setTimeout(() => window.URL.revokeObjectURL(url), 30000);
  return preview_window;
};
